export default __webpack_public_path__ + "static/media/stool_consistency_chart.1d56985b.png";